import { Model } from '@models/model';
import { Paginated } from '@models/paginated';

export class SmsHistoryDetails extends Paginated {
  data: Array<SmsHistoryDetail>;
}

export class SmsHistoryList extends Paginated {
  data: Array<SmsHistory>;
}

export class SmsHistoryDetail extends Model {
  createTime: string;
  campaignName: string;
  encoding: string;
  period: Period;
  dynamic: Dynamic;
  idMessage: string;
  idMessageType: string;
  recipients: number;
  scheduleType: string;
  sender: string;
  sentFrom: string;
  message: string;
  isRichsms: string;
  statusCount: StatusCount;
  dateForSend: string;
  rcptNumber: string;
  messageStatus: string;
  sendDate: string;
  totalClicks: number;
  firstClickDate: string;
  lastClickDate: string;
  deliveryDate: string;
  status: number;
}

export class SmsHistory extends Model {
  createTime: string;
  campaignName: string;
  encoding: string;
  period: Period;
  dynamic: Dynamic;
  idMessage: string;
  idMessageType: string;
  recipients: number;
  scheduleType: string;
  sender: string;
  sentFrom: string;
  message: string;
  isRichsms: string;
  dateForSend: string;
  statusCount: StatusCount;
}

export class Period extends Model {
  'id-period': number;
  'num-repetitions': number;
  infinitive: string;
}

export class Dynamic extends Model {
  'id-field': string;
  postpone: string;
  'num-days': number;
  'send-time': string;
}

export class ApiGetSubaccountSmsDetailHistoryOptions {
  idSubaccount: number;
  idMessage: string;
  isRichsms: boolean;
}

export class ApiGetSmsDetailHistoryOptions {
  idMessage: string;
  isRichsms: boolean;
}

export class ApiGetSmsSubaccountListHistoryOptions {
  idSubaccount: number;
  dateFrom: string;
  dateTo: string;
}

export class ApiGetSmsListHistoryOptions {
  dateFrom: string;
  dateTo: string;
  recipient: string;
}

export enum filterKey {
  period = 'period',
  fromDateKey = 'fromDate',
  fromTimeKey = 'fromTime',
  toDateKey = 'toDate',
  toTimeKey = 'toTime',
  recipient = 'recipient'
}

export class StatusCount {
  [key: string]: Value;
}

export class Value extends Model {
  sms: number;
  credits: number;
}

export enum SmsScheduleType {
  periodic = 'periodic',
  scheduled = 'scheduled',
  recurring = 'recurring'
}
